export default function mapPricingToSave (data:any){
	console.log(data)
	return {
		"price_model": (data.price_model?.value || "").toLowerCase(),
		"name": data.name,
		"price": Number(data.price),


		"rule_config": {
			"rules":
				data.price_model?.value === "FIXED"
					?
					[]
					:

					data.rules?.map((item: { tier: any; price_rule: { value: any; }; value: any; }) => ({
						"tier": Number(item.tier),
						"price_rule": (item.price_rule?.value || "").toLowerCase(),
						"value": Number(item.value)
					})),
			"subsequent_rule": !data.price_rule?.value ? null : {
				"price_rule":
					data.price_model?.value === "FIXED" ?
						null
						:
						(data.price_rule?.value || "").toLowerCase(),
				"value":
					(data.price_model?.value === "FIXED") ?
						0
						:
						Number(data.subsequentValue) || 0
			}
		},

		"max_price_total": Number(data.max_price_total),
		"min_price_total": Number(data.min_price_total),



		"discount": 30,
		"discount_type": "value",
		"discount_model": "discount_on_addition",
	}
}